<ng-container *transloco="let t">
  <div id="sidenav-active-background" *ngIf="sideNavVisible" (click)="toggleSidenav()"></div>

  <header class="header ran-blue-background">
    <button mat-icon-button (click)="toggleSidenav()" class="menu-button" disableRipple *ngIf="userService?.user">
      <mat-icon>menu</mat-icon>
    </button>
    <img src="assets/r.png" class="logo" />
    <h1>
      Flow<small *ngIf="development"> (DEV)</small>

      <button
        *ngIf="userService?.testedUser"
        (click)="userService.resetTestedUser()"
        mat-icon-button
        color="warn"
        [matTooltip]="t('common.testingUserPermissions', { name: userService.testedUser.name })"
        style="margin-left: 15px"
      >
        <mat-icon>warning</mat-icon>
      </button>
    </h1>

    <div class="user">
      <ng-container *ngIf="userService?.user">
        <mat-icon class="inline-icon user-icon">account_circle</mat-icon>
        <span class="hidden-xs">{{ userService.user.name }}</span>
        <span class="hidden-lg">{{ formatUserName(userService.user.name) }}</span>
      </ng-container>
    </div>
  </header>

  <aside class="sidenav mat-elevation-z6" [class.active]="sideNavVisible">
    <app-side-nav></app-side-nav>
    <!-- <div id="theme"> -->
    <!--   <button mat-button (click)="themeService.toggleTheme()"> -->
    <!--     <mat-icon>{{ themeService.darkMode ? 'wb_sunny' : 'nights_stay' }}</mat-icon> Vaihda teemaa -->
    <!--   </button> -->
    <!-- </div> -->
    <div id="licenses" *ngIf="userService?.user">
      <a href="javascript:" (click)="displayLicenses()">{{ t('common.licenses') }}</a>
    </div>
  </aside>

  <main class="main" [class.is-iframe]="isIframe">
    <div [class.hide-child-component]="routerLoading">
      <router-outlet #o="outlet"></router-outlet>
    </div>

    <div id="component-loading-background" *ngIf="routerLoading"></div>
    <div id="component-loading" *ngIf="!userService?.user && state !== 'loadUserManually'">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>

    <div id="app-loading" *ngIf="state">
      <span *ngIf="state === 'loadUser'">Ladataan käyttäjätiedot / Laddar användardata</span>
      <div *ngIf="state === 'loadUserManually'">
        Virhe - käyttäjätietoja ei voitu ladata<br />
        Fel - användardata kunde inte laddas<br /><br />

        <button mat-button class="primary" (click)="reload()">Lataa uudelleen - Ladda om</button>
      </div>
    </div>
  </main>

  <!-- footer class="footer"></footer -->
</ng-container>
